export const footerMenuItems = [
 
  {
    id: '1',
    icon: '',
    title: 'Услуги',
    path: '/services',
    isSpecial: false,
  },
  {
    id: '2',
    icon: '',
    title: 'Акции',
    path: '/promotions',
    isSpecial: false,
  },
  {
    id: '3',
    icon: '',
    title: 'Новости',
    path: '/news',
    isSpecial: false,
  },
  {
    id: '4',
    icon: '',
    title: 'О нас',
    path: '/about_clinic',
    isSpecial: false,
  },
  {
    id: '5',
    icon: '',
    title: 'Врачи',
    path: '/doctors',
    isSpecial: false,
  },
  {
    id: '6',
    icon: '',
    title: 'Пациентам',
    path: '/patients',
    isSpecial: false,
  },
  {
    id: '7',
    icon: '',
    title: 'Контакты',
    path: '/contacts',
    isSpecial: false,
  },
  {
    id: '8',
    icon: '',
    title: 'Статьи',
    path: '/articles',
    isSpecial: false,
  },
  {
    id: '9',
    icon: '',
    title: 'Отзывы',
    path: '/testimonials',
    isSpecial: false,
  },
];